var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imageDiv"},[_c('ImageLoader',{staticClass:"image",attrs:{"src":_vm.asyncImageSrc != null ? _vm.asyncImageSrc : ''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }